import CloseIcon from '@mui/icons-material/Close';
import { styled } from '@mui/material';

export const Section = styled('section')(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  paddingTop: '2rem',
}));

export const AlignLeft = styled('section')(() => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'left',
  alignItems: 'left',
  textAlign: 'left',
  gap: '1rem',
}));

export const Container = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  color: theme.palette.common.white,
  background: theme.palette.primary.main,
  borderRadius: '0.75rem',
  padding: '1.5rem',

  [theme.breakpoints.up('md')]: {
    padding: '2rem',
  },
}));

export const StyledCloseIcon = styled(CloseIcon)(() => ({
  marginBottom: '1rem',
  alignSelf: 'flex-end',
  cursor: 'pointer',
}));

export const AlignButtons = styled('div')(() => ({
  display: 'flex',
  paddingTop: '1rem',
  justifyContent: 'right',
}));
